<template>
  <div>
    <b-row v-if="loadingData">
      <b-col>
        <spinner style="margin-top: 20px;"></spinner>
      </b-col>
    </b-row>
    <b-row v-if="!loadingData" class="p-3">
      <b-col sm="12">
        <b-card>
          <div slot="header">
            Status dos Servidores
          </div>
          <div v-for="server in servers" :key="server._id" :style="{color: (server.status ? 'black' : 'red')}">
            {{server.name}}: <b>{{(server.status ? "Ativo" : "Fora do Ar")}}</b>
          </div>
        </b-card>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <i class="fa fa-money-o"></i> Resumo
          </div>
          <b-form>
            <b-form-group
              label="Total de usuários:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.totalUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Pagantes:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.payingUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="FREEPASS:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.freepassUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="VIP:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.vipUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Premium:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.premiumUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label="Usuários Free Ativos:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.freeUsers"></b-form-input>
              </b-input-group>
            </b-form-group>
            <!--<b-form-group
              v-if="whitelabel"
              label="Dias disponíveis:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-model="info.totalDays"></b-form-input>
              </b-input-group>
            </b-form-group>-->
            <b-form-group
              v-if="whitelabel"
              label="Vencem hoje:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-if="info && info.dueToday" v-model="info.dueToday.length"></b-form-input>
                <a href="#" v-if="info && info.dueToday && info.dueToday.length" @click="showDue(info.dueToday)">Ver lista</a>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="whitelabel"
              label="Vencem nos próximos 7 dias:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-if="info && info.due7days" v-model="info.due7days.length"></b-form-input>
                <a href="#" v-if="info && info.due7days && info.due7days.length" @click="showDue(info.due7days)">Ver lista</a>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-if="whitelabel"
              label="Vencem este mês:"
              label-for="basicStatic"
              :label-cols="4"
              :horizontal="true"
            >
              <b-input-group>
                <b-form-input plaintext id="basicStatic" type="text" v-if="info && info.dueThisMonth" v-model="info.dueThisMonth.length"></b-form-input>
                <a href="#" v-if="info && info.dueThisMonth && info.dueThisMonth.length" @click="showDue(info.dueThisMonth)">Ver lista</a>
              </b-input-group>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>

      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-money-o"></i> Filtrar Usuários
          </div>

          <b-form>
            <b-form-group>
              <b-row>
                <b-col lg="6">
                  <label for="email-input">Email</label>

                  <input class="form-control" type="text" v-model="emailSearch" />
                </b-col>
                <b-col lg="6">
                  <label for="email-input">Telefone</label>

                  <input class="form-control" type="text" v-model="phoneSearch" />
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <label for="email-input">Nome</label>

                  <input class="form-control" type="text" v-model="nameSearch" />
                </b-col>
                <b-col class="col-lg-6">
                  <label for="email-input">Tipo de Conta</label>

                  <b-form-select v-model="accountType" class="mb-3">
                    <option :value="undefined">Todos</option>
                    <option value="2">FREE</option>
                    <option value="1">Premium</option>
                  </b-form-select>
                </b-col>
                  <b-col class="col-lg-6">
                  <label for="email-input">Situaçao</label>

                  <b-form-select v-model="subscriptionStatus" class="mb-3">
                    <option :value="undefined">Todos</option>
                    <option value="0">Ativo</option>
                    <option value="1">Expirado</option>
                  </b-form-select>
                </b-col>
                <b-col class="col-lg-4 mt-4">
                  <b-button class="btn btn-primary" @click="getUsersItems()">
                    <i class="fa fa-search"></i> Buscar
                  </b-button>
                </b-col>
                <b-col class="col-lg-8 mt-4 text-right">
                  <b-button variant="primary" @click="listAll()">
                    <i class="fa fa-list"></i> Ver todos
                  </b-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="nothingAvailable">
      <b-col>
        <h4>Nada Encontrado</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card v-if="items && items.length > 0 && !loadingData" :header="caption">
          <b-table
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="captions"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template #cell(subscription)="data">
              <div>
                <b-badge v-if="data.item.subscription.status"
                  :variant="getSubscriptionBadge(data.item.subscription.status)"
                >{{(parseInt(data.item.subscription.status) === 0 || parseInt(data.item.subscription.status) === 2 )? "Free" : (parseInt(data.item.subscription.status) === 1) ? "Prem. Ilimitado" : "Prem. " + data.item.subscription.credits}}</b-badge>
              </div>
            </template>
            <template #cell(name)="data">
              <a v-bind:href="'/reseller/user/' + data.item._id" target="_blank">
                <div>{{data.item.name}}</div>
              </a>
            </template>
            <template #cell(email)="data">
              <!-- <b-button size="sm" @click="showDetails(data.item._id)"> -->
              <a v-bind:href="'/reseller/user/' + data.item._id" target="_blank">
                <div>{{data.item.email}}</div>
              </a>
              <!-- </b-button> -->
            </template>
            <template #cell(instagram)="data">
              <div>
                <a v-if="(data.item.instagram)"
                  target="_blank"
                  v-bind:href="'https://instagram.com/' + data.item.instagram.replace('@','')"
                >{{data.item.instagram}}</a>
              </div>
            </template>
            <template #cell(whitelabel)="data">
                <div>{{data.item.whitelabelName}}</div>
              <!-- </b-button> -->
            </template>
            <template #cell(whatsapp)="data">
              <div>
                <a
                  target="_blank"
                  v-bind:href="'https://api.whatsapp.com/send?l=pt_BR&phone=55' + data.item.whatsapp"
                >{{data.item.whatsapp}}</a>
              </div>
            </template>
            <template #cell(editions)="data">
              <div>
                {{data.item.subscription.startedEditionCount}}
                <a
                  v-bind:href="'/user/edition/' + data.item._id"
                  target="_blank"
                  v-if="data.item.subscription.startedEditionCount > 0"
                >
                  <div>Detalhes</div>
                </a>
              </div>
            </template>
            <template #cell(creation)="data">
              <div>{{data.item.createdAt._now | moment("DD/MM/YYYY HH:mm")}}</div>
            </template>
              <template #cell(due)="data">
              <div>{{data.item.subscription.due | moment("DD/MM/YYYY HH:mm")}}</div>
            </template>
            <template #cell(couponName)="data">
              <div v-if="data.item.couponName">{{data.item.couponName}}</div>
              <div v-else>Sem Cupom</div>
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Anterior"
              next-text="Próxima"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: "AdminList",
  inheritAttrs: false,
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 20
    },
    dark: {
      type: Boolean,
      default: false
    },
    whitelabel: false
  },
  data: () => {
    return {
      currentPage: 1,
      emailSearch: undefined,
      phoneSearch: undefined,
      nameSearch: undefined,
      accountType: undefined,
      subscriptionStatus: undefined,
      nothingAvailable: false,
      userDetails: [],
      loadingData: false,
      info: {},
      caption: "Listagem de Clientes",
      me: undefined,
      servers: []
    };
  },
  computed: {
    items: function() {
      return this.userDetails;
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    fields: function() {
      let baseFields = [
        {
          label: "Nome",
          sortable: true,
          key: "name"
        },
        {
          label: "Email",
          sortable: true,
          key: "email"
        },
        {
          label: "Tipo Assinatura",
          sortable: true,
          key: "subscription"
        },
        {
          //key: "subscription.editionCount",
          label: "Edições iniciadas",
          sortable: true,
          key: "editions"
        },
        {
          label: "Data de Criação",
          sortable: true,
          key: "creation"
        },
        {
          label: "Data de Expiração",
          sortable: true,
          key: "due"
        },
        {
          label: "Instagram",
          sortable: true,
          key: "instagram"
        },
        {
          label: "Cupom",
          sortable: true,
          key: "couponName"
        }
      ]

      if (this.whitelabel) {
        baseFields.push({
          label: "Whatsapp",
          sortable: true,
          key: "whatsapp"
        });
      } else {
        baseFields.push({
          label: "Whitelabel",
          sortable: true,
          key: "whitelabel"
        });
      }

      return baseFields;
    }
  },
  methods: {
    showDue(duePeople) {
      let string = "";
      for (let key in duePeople) {
        string += duePeople[key].email + " " + duePeople[key].subscription.recurrent + "\n";
      }

      alert(string);
    },
    getSubscriptionBadge(paymentStatus) {
      return (paymentStatus === 0 || paymentStatus === 2) ? "primary" : "success";
    },
    getRowCount: function() {
      return this.items.length;
    },
    getPlatformDetails: function() {
      let searchParams = {
        emailSearch: this.emailSearch,
        phoneSearch: this.phoneSearch,
        nameSearch: this.nameSearch,
        accountType: this.accountType,
        subscriptionStatus: this.subscriptionStatus
      };

      this.loadingData = true;
      service.getPlatformDetails({ searchParams }).then(response => {
        this.loadingData = false;
        this.userDetails = response.userDetails;
        this.info = response.info;
        if (response.userDetails.length == 0) {
          this.nothingAvailable = true;
        }
      });
    },
    getWhitelabelDetails: function() {
      let searchParams = {
        emailSearch: this.emailSearch,
        phoneSearch: this.phoneSearch,
        nameSearch: this.nameSearch,
        accountType: this.accountType,
        subscriptionStatus: this.subscriptionStatus
      };

      this.loadingData = true;
      service.getWhitelabelDetails({ searchParams }).then(response => {
        this.loadingData = false;
        this.userDetails = response.userDetails;
        this.info = response.info;
        if (response.userDetails.length == 0) {
          this.nothingAvailable = true;
        }
      });
    },
    showDetails: function(userId) {
      this.$router.push("/reseller/user/" + userId);
    },
    getUsersItems() {
      this.nothingAvailable = false;
      if (this.whitelabel) {
        this.caption = "Meus clientes";
        this.getWhitelabelDetails();
      } else {
        this.getPlatformDetails();
      }
    },
    getMe: function() {
      service.getMe().then(
        response => {
          this.me = response;
          console.log(this.me);
          if (this.me.adminType == 1) {
            this.$router.push("/admin/sales");
          }
        },
        () => {
          this.showError = true;
        }
      );
    },
    listAll: function() {
      if (this.whitelabel) {
        this.caption = "Meus clientes";
        this.getWhitelabelDetails();
      } else {
        this.getPlatformDetails();
      }
    }
  },
  components: { Spinner },
  created() {
    this.getMe();
    service.getServers().then(result => {
      this.servers = result.servers;
    });
  }
};
</script>


